/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import Image, { ImageProps } from 'next/image';
import React, { FC, useMemo } from 'react';

import config from '@/config';

/**
 * Brand logo
 */
const BrandLogo: FC<Partial<ImageProps>> = ({ ...props }) => {
  const brandSrc = useMemo(() => {
    return `/images/${config.public.brandName}/icon.svg`;
  }, []);

  return <Image src={brandSrc} width={40} height={40} {...props} />;
};

export default BrandLogo;
